<template>
  <div v-html="markdown" class="markdown"></div>
</template>
<script>
import { defineComponent } from "vue";
var md = require("markdown-it")({
  breaks: true,
  html: false,
  linkify: true,
})
  .use(require("markdown-it-ins"))
  .use(require("markdown-it-mark"));
export default defineComponent({
  name: "Markdown",
  props: ["value"],
  computed: {
    markdown() {
      if (this.value) {
        let doc = new DOMParser().parseFromString(this.value, "text/html");
        return md.render(doc.body.textContent);
      }
      return "";
    },
  },
});
</script>
<style scoped>
.markdown :deep(h1),
.markdown :deep(h2),
.markdown :deep(h3),
.markdown :deep(h4) {
  font-size: medium !important;
  font-weight: bold !important;
  margin-top: 3ex;
}
.markdown :deep(h1:first-child),
.markdown :deep(h2:first-child),
.markdown :deep(h3:first-child),
.markdown :deep(h4:first-child) {
  margin-top: 0ex;
}
.markdown :deep(> ul) {
  padding-bottom: 2ex;
}
.markdown :deep(> p) {
  margin-bottom: 1ex;
}
.markdown :deep(li) {
  padding-bottom: 0.5ex;
}
.markdown :deep(li:last-child) {
  padding-bottom: 3ex;
}
</style>
